import { colors } from "Constants";

const styles = {
  journalIconStyle: {
    backgroundColor: colors.blue900,
  },
  familyIconStyle: {
    backgroundColor: colors.green900,
  },
  announcementIconStyle: {
    backgroundColor: colors.violet900,
  },
  todosIconStyle: {
    backgroundColor: colors.pink900,
  },
  reportIconStyle: {
    backgroundColor: colors.teal900,
  },
  progressSummaryIconStyle: {
    backgroundColor: colors.teal900,
  },
  calendarIconStyle: {
    backgroundColor: colors.yellow900,
  },
  schoolPolicyStyle: {
    backgroundColor: colors.purple900,
  },
  learnerPortfolioStyle: {
    backgroundColor: colors.blue900,
  },
  thirdPartyRedirectUrlStyle: {
    backgroundColor: colors.blue900,
  },
  sentralTileStyle: {
    backgroundColor: colors.pink900,
  },
  buttonDropDownContainerStyle: {
    top: "50px",
    left: "44px",
    borderRadius: "8px",
    padding: "20px",
  },
  buttonCardStyle: {
    width: "380px",
  },
  profileCascadeStyleOne: {
    width: "40px",
    height: "40px",
  },
  profileCascadeStyleTwo: {
    width: "24px",
    height: "24px",
  },
  customTextStyle: {
    fontSize: "1rem",
  },
  selectedChildProfile: {
    border: `2px solid ${colors.red66}`,
  },
  timetable: {
    backgroundColor: colors.orange900,
  },
  attendance: {
    backgroundColor: colors.yellow900,
  },
  studentProfile: {
    backgroundColor: colors.pink900,
  },
  behaviourManagement: {
    backgroundColor: colors.violet900,
  },
  sso: {
    backgroundColor: colors.green900,
  },
  mbSponte: {
    backgroundColor: colors.pink900,
  },
  containerStyle: {
    height: "100%",
  },
  emptySubTitleStyle: {
    width: "560px",
    color: colors.black,
    marginTop: "12px",
  },
};

export default styles;
